export const environment = {
	environment: 'development',
	production: false,
	cookieName: '__FUTURA_SETTINGS__',
	locale: 'it-IT'
};
